import {put, select, takeLatest} from 'redux-saga/effects';

//Actions
import * as actions from '../../actions';

//Types
import {AxiosResponse} from 'axios';
import JSONFormData from '../../../utils/JSONFormData';
import {Account} from '../../../services/endpoints';
import {api} from '../../services/axios';
import {ReduxState} from '../../types';
import { ExtensionType } from '../../types/Extension';
import {ActionType} from 'typesafe-actions';
import { RingGroupType } from '../../types/RingGroup';
import { editServiceFeatures } from '../extensions/serviceFeatures/saga';

export function* getAccountPanelAccountDetails() {
    try {
        const {session_id, csrf_token} = yield select(
            (state: ReduxState) => state.auth,
        );

        const body = new JSONFormData(session_id, csrf_token);
        body.setParams({
            detailed_info: 1,
            limit_alias_did_number_list: 100
        });

        const response: AxiosResponse<{
            account_info: ExtensionType;
        }> = yield api.post(Account.GetAccountInfo, body);

        yield put(actions.getAccountPanelAccountDetails.success(response.data.account_info));
    } catch (err) {
        yield put(actions.getAccountPanelAccountDetails.failure());
    }
}

export function* getLastWrapUpActiveCall(action: ActionType<typeof actions.getLastWrapUpActiveCall.request>) {
    try {
        const {session_id, csrf_token} = yield select(
            (state: ReduxState) => state.auth,
        );

        const body = new JSONFormData(session_id, csrf_token);
        body.setParams(action.payload);

        const response: AxiosResponse<{
            active_session_info: {
                release_time?: string,
                huntgroup_id?: string
            };
        }> = yield api.post(Account.GetLastWrapUpActiveCall, body);

        if(response.data.active_session_info?.huntgroup_id) {
            const response2: AxiosResponse<{
                huntgroup_list: RingGroupType[];
            }> = yield api.post(Account.GetAccountHuntGroupsList, body);

            const ringGroup = response2?.data?.huntgroup_list?.find(e => e.id == response.data.active_session_info?.huntgroup_id);

            yield put(actions.getLastWrapUpActiveCall.success({
                release_time: response.data.active_session_info?.release_time,
                call_wrap_up_time: ringGroup?.call_wrap_up_time,
                wrap_up_extend_time: ringGroup?.wrap_up_extend_time
            }));
        }
        else if(response.data.active_session_info?.release_time) {
            yield put(actions.getLastWrapUpActiveCall.success({
                release_time: response.data.active_session_info?.release_time
            }));
        }
        else {
            yield put(actions.getLastWrapUpActiveCall.success(undefined));
        }
    } catch (err) {
        yield put(actions.getLastWrapUpActiveCall.failure());
    }
}

export function* setWrapUpTime(action: ActionType<typeof actions.setWrapUpTime.request>) {
    try {
        const {session_id, csrf_token} = yield select(
            (state: ReduxState) => state.auth,
        );

        const body = new JSONFormData(session_id, csrf_token);
        body.setParams(action.payload);

        yield api.post(Account.SetWrapUpTime, body);
        action.payload.callback?.();

        yield put(actions.setWrapUpTime.success());
    } catch (err) {
        yield put(actions.setWrapUpTime.failure());
    }
}

export function* updateForwardingModel(action: ActionType<typeof actions.updateForwardingModel.request>) {
    try {
        yield editServiceFeatures(
            action.payload.i_account,
            action.payload.serviceFeatures,
        );

        action.payload.callback?.();

        yield put(actions.updateForwardingModel.success());
    } catch (err) {
        yield put(actions.updateForwardingModel.failure());
    }
}

export const accountControlPanelSaga = [
    takeLatest(actions.getAccountPanelAccountDetails.request, getAccountPanelAccountDetails),
    takeLatest(actions.getLastWrapUpActiveCall.request, getLastWrapUpActiveCall),
    takeLatest(actions.setWrapUpTime.request, setWrapUpTime),
    takeLatest(actions.updateForwardingModel.request, updateForwardingModel),
];
